export default __webpack_public_path__ + "static/media/1240.0a3a99e4.jpeg";